import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  cloudPlatformContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    position: "relative",
    zIndex: 1
  },
  cloudPlatformTitle: {
    width: "100%",
    textAlign: "center",
    marginBottom: 80,
    "@media (max-width: 1200px)": {
      marginBottom: 80,
      textAlign: "left"
    },
    "@media (max-width: 600px)": {
      marginBottom: 40
    }
  },
  cloudPlatformSubtitle: {

  },
  cardsContainer: {
    width: "100%",
  },
  cardItem: {
    "@media (max-width: 1200px)": {
      textAlign: "left"
    },
    "& + $cardItem": {
      marginTop: 160,
      "&.comment-card": {
        marginTop: 64
      },
      "@media (max-width: 1200px)": {
        marginTop: 120
      },
      "@media (max-width: 600px)": {
        marginTop: 80,
        "&.comment-card": {
          marginTop: 40
        }
      }
    },
    //Variations
    "&.comment-card": {
      filter: "drop-shadow(6px 14px 64px rgba(58, 40, 167, 0.1))"
    },
    "&.cloud-platform-events-card": {}
  }
});
